<template>

    <div>

        <b-card v-if=" !isCarrierManager ">

            <b-button variant="primary" @click="passwordModal = true" v-if=" enrolled"><i class="fa fa-lock"></i> Reset Password</b-button>
            <b-button variant="default" @click="sendEnrollmentEmail()" :disabled="!hasEmail" v-if=" !enrolled"><i class="fa fa-mail-forward"></i> Send Enrollment Email</b-button>
            <b-button variant="info" @click="createEnrollmentLetter()" v-if=" !enrolled && client.uses_enrollment_queue"><i class="fa fa-envelope-o"></i> Send Enrollment Letter</b-button>
            <b-button variant="default" @click="sendTrainingEmail()" v-if=" enrolled && client.active"><i class="fa fa-mail-forward"></i> Send Training Email</b-button>
            <b-button variant="info" :href="`/${controller}/support/impersonate/${client.id}`" v-if=" enrolled && client.active"><i class="fa fa-user-secret"></i> Impersonate Claimant</b-button>
            <b-button variant="danger" @click="archiveClient()" v-if="client.active"><i class="fa fa-times"></i> Deactivate Claimant</b-button>
            <b-button variant="info" @click="reactivateClient()" v-else><i class="fa fa-refresh"></i> Re-activate Claimant</b-button>
            <b-button variant="secondary" :href="`${claimantUrlPrefix}/${client.id}/decommission_notice/pdf`" v-if=" enrolled && !client.active"><i class="fa fa-file-pdf-o"></i> Deactivation PDF</b-button>
            <b-button variant="secondary" :href="`${claimantUrlPrefix}/${client.id}/decommission_notice/tiff`" v-if=" enrolled && !client.active"><i class="fa fa-file-image-o"></i> Deactivation TIFF</b-button>
            <b-button variant="secondary" @click.prevent="sendTiff()" v-if="enrolled && !client.active">
                <i class="fa fa-file-image-o"></i> Retransmit Deactivation Notice
            </b-button>

            <div class="decommission-text" v-if="!client.active">

                Decommissioned: {{ client.decommissioned_at ? formatDate( client.decommissioned_at ) : 'No Date Available' }}
                <span v-if=" client.decommission_reason "> - {{ client.decommission_reason }}</span>
            </div>
        </b-card>
        <b-card v-else>

            <div class="decommission-text" v-if="!client.active">

                Decommissioned: {{ client.decommissioned_at ? formatDate( client.decommissioned_at ) : 'No Date Available' }}
                <span v-if=" client.decommission_reason "> - {{ client.decommission_reason }}</span>
            </div>
        </b-card>

        <b-alert v-if="create" variant="info" class="mb-4" show>Please choose an option for sending enrollment details to claimant.</b-alert>

        <mfa-configure-collapsible :user="this.client.user" :sms_phone_number='this.client.user.sms_phone_number' :is_mfa_enabled="this.client.user.is_mfa_enabled"></mfa-configure-collapsible>

        <admin-audit-log
            :role="role"
            :scopedUserId=" client.id "
        />

        <b-row v-if="create">

            <b-col>

                <b-btn variant="success" size="lg" :href="`${claimantUrlPrefix}/${client.id}`">Save</b-btn>
                <!-- <b-btn variant="info" size="lg" href="/business/clients/create">Create Another Policyholder</b-btn> -->
            </b-col>
        </b-row>

        <reset-password-modal v-model=" passwordModal " :url=" `${this.claimantUrlPrefix}/${client.id}/password` "></reset-password-modal>
        <decommission-modal v-model=" decommissionModal " :user="client.user" @confirm="e => archiveClient(true, e)" />
    </div>
</template>

<script>
    import UsesRole from "../../../mixins/UsesRole";
    import EnrollmentStatuses from "../../../mixins/EnrollmentStatuses";
    import FormatsDates from "../../../mixins/FormatsDates";

    export default {

        name: "ClientManage",
        props: {

            client: {

                type: Object,
                default() {
                    return { id: 0 }
                }
            },
            create: Boolean,
            carriers: {

                type: Array,
                default: () => { return []; },
            },
            user: {},
        },

        data(){

            return {

                passwordModal     : false,
                decommissionModal : false,
            }
        },

        mixins: [EnrollmentStatuses, UsesRole, FormatsDates],

        computed: {

            hasEmail() {
                return !! this.client.email;
            },
            enrolled() {
                return this.isEnrolled(this.client.enrollment_status);
            },
        },
        methods: {
            async sendTiff() {
                if (confirm('Are you sure you wish to submit the decommission notice?')) {
                    let form = new Form({});
                    await form.post(`${this.claimantUrlPrefix}/${this.client.id}/decommission_notice/submit`);
                }
            },
            archiveClient(confirmed = false, reason = '') {
                if (! confirmed) {
                    this.decommissionModal = true;
                    return;
                }

                let form = new Form({ reason });
                form.post(`${this.claimantUrlPrefix}/${this.client.id}/deactivate`)
                .then(({ data }) => this.client = data.data);
            },

            reactivateClient() {
                if (confirm('Are you sure you wish to re-activate ' + this.client.name + '?')) {
                    let form = new Form({});
                    form.post(`${this.claimantUrlPrefix}/${this.client.id}/reactivate`)
                    .then(({ data }) => this.client = data.data);
                }
            },

            deleteClient() {
                if (!confirm(`Are you sure you want to delete ${this.client.name}?`)) {
                    return;
                }

                if (!confirm(`Really delete ${this.client.name}?  This cannot be undone.`)) {
                    return;
                }

                let form = new Form({});
                form.submit('delete', `${this.claimantUrlPrefix}/${this.client.id}`)
                .then( response => {} )
            },

            createEnrollmentLetter() {
                const url = `/business/enrollment-queue/${this.client.id}/letter`;
                const form = new Form({});
                form.post(url);
            },

            sendEnrollmentEmail() {
                let form = new Form({});
                form.post(`${this.claimantUrlPrefix}/${this.client.id}/send_enrollment_email`);
            },

            sendTrainingEmail() {
                let form = new Form({});
                form.post(`${this.claimantUrlPrefix}/${this.client.id}/send_training_email`);
            }
        },

        mounted() {
            // Debugging for Development
            console.log("Caregiver Data");
            console.debug("Caregiver", this.caregiver);
        }
    }
</script>

<style scoped>

</style>